import { Box, Typography } from "@mui/material";
import theme from "../../../theme";
import { useTranslation } from "react-i18next";

type Props = {
  reasonText: string | undefined;
};

export const CancelReasonBanner = ({ reasonText }: Props) => {
  const { t } = useTranslation();

  return reasonText ? (
    <Box
      p={0.5}
      pl={4}
      m={-2}
      mb={2}
      sx={{
        backgroundColor: theme.palette.error.main,
      }}
    >
      <Typography color="white">
        {t("order:orderCancelled")}: {t(`order:${reasonText}`)}
      </Typography>
    </Box>
  ) : null;
};
